import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { FullPageLoader } from "@/components/FullPageLoader";
import { loginWithNext } from "@/lib/navigation";
import { ROUTES } from "@/constants/routes";

export function ProtectedRoute() {
  const { session, loading, signedOutManually } = useAuth();
  const location = useLocation();
  if (loading) return <FullPageLoader label="Checking your session" />;
  if (!session) {
    const to = signedOutManually ? ROUTES.login : loginWithNext(location.pathname + location.search);
    return <Navigate to={to} replace />;
  }
  return <Outlet />;
}
